var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"globalHost",staticClass:"blk fp global-host ys position-relative",attrs:{"id":"app"}},[_c('nav-bar'),_c('contact-me'),_c('mini-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }